<template>
  <div class="plan" :class="{ free: name === 'Free' }">
    <h4>{{ name }}</h4>
    <p>{{ descritption }}</p>
    <h1>{{ price }}</h1>
    <p class="price-desc">{{ priceDesc }}</p>

    <a :href="link" class="button" :class="linkType" @click="buttonClicked('price')">{{ linkName }}</a>

    <p class="list-intro" v-if="name != 'Free'">Includes everything in Free, plus:</p>
    <ul>
      <li v-for="feature in features" :key="feature">{{ feature }}</li>
    </ul>

    <p class="disclaimer">{{ asterisk }}</p>
  </div>
</template>

<script>
import BaseComponent from '@/components/BaseComponent'

export default {
  name: 'PriceCard',
  mixins: [BaseComponent],
  props: {
    name: String,
    descritption: String,
    price: String,
    priceDesc: String,
    features: Array,
    link: String,
    linkType: String,
    linkName: String,
    asterisk: String,
  },
}
</script>

<style lang="scss" scoped>
p {
  margin: 0 0 36px;
  &.list-intro {
    margin: 0 0 12px;
  }
}

.plan {
  border-radius: 14px;
  padding: 24px 24px 36px;
  text-align: left;
  position: relative;
  border: 1px solid $blue;
  box-shadow: 0 10px 20px 0 rgba(75, 97, 238, 0.15);
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;

  @include respond-above(xs) {
    padding: 36px 36px 36px;
  }

  @include respond-above(sm) {
    max-width: 380px;
    margin: 0 12px;
    &:first-of-type {
      margin-left: 0;
    }
    &:last-of-type {
      margin-right: 0;
    }
  }

  @include respond-above(md) {
    margin: 0 24px;
  }

  h1 {
    margin: 0 0 0px;
  }

  p {
    margin-bottom: 24px;
  }

  ul {
    margin: 0px 0 24px;
    padding-left: 24px;

    list-style-image: url('~@/assets/feature-checkmark.svg');
    li {
      padding: 0 0 12px 12px;
      line-height: 1.34em;
    }
  }

  .button {
    display: block;
    margin: 0px 0 0px;
    order: 1;
    @include respond-above(sm) {
      order: 0;
      margin: 0px 0 48px;
    }
  }
  .disclaimer {
    color: $grayD;
    font-size: 14px;
    margin: 12px 0 0;
    order: 2;
    @include respond-above(sm) {
      order: 0;
    }
  }

  @include respond-above(sm) {
    .price-desc {
      min-height: 60px;
    }
  }
}

.free {
  background-color: $grayL;
  border-color: $grayL;
  box-shadow: none;
}
</style>
